module.exports = __webpack_public_path__ + "img/deal.c318033f.svg";